import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface'

export default class CreateDNSZoneForm {
  public websiteId: number = 0

  public server: string = ''

  public adminOnly: boolean = false;

  public overwrite: boolean = false;

  public rules(): { [name: string]: FormValidationFunction[] } {
    return {
      websiteId: [
        (v: number) => !!v || 'Website is required',
        (v: number) => v > 0 || 'Invalid Website',
      ],
    }
  }
}
